import "./tip.scss"

